// Petit toast générique (succès/info/attention), utilisé pour prévenir
// l'utilisateur quand on doit ajuster silencieusement ce qu'il demande
// (ex: quantité plafonnée au stock promo restant) — mieux qu'un simple
// console.log ou rien du tout : il comprend pourquoi le chiffre affiché
// n'est pas celui qu'il attendait.
// SVG inline : la vitrine ne charge pas FontAwesome (seul le layout admin
// le fait), donc un <i class="fas …"> n'y rend qu'une boîte vide.
const WARNING_ICON = `
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M10.3 3.9 1.8 18.2A2 2 0 0 0 3.5 21.2h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>
    <path d="M12 9v4M12 17h.01"/>
  </svg>`

const SUCCESS_ICON = `
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9"/>
    <path d="m8.5 12.2 2.4 2.4 4.6-4.8"/>
  </svg>`

let container = null

function getContainer() {
  if (container && document.body.contains(container)) return container
  container = document.createElement("div")
  container.className = "vitrine-toast-container"
  document.body.appendChild(container)
  return container
}

export function showToast(message, { type = "success", duration = 3500 } = {}) {
  const el = document.createElement("div")
  el.className = `vitrine-toast vitrine-toast--${type}`
  el.setAttribute("role", "status")
  el.innerHTML = `
    <span class="vitrine-toast-icon">${type === "warning" ? WARNING_ICON : SUCCESS_ICON}</span>
    <span class="vitrine-toast-message">${message}</span>
  `

  getContainer().appendChild(el)
  requestAnimationFrame(() => el.classList.add("is-visible"))

  setTimeout(() => {
    el.classList.remove("is-visible")
    setTimeout(() => el.remove(), 250)
  }, duration)
}
